import type {
  BookingFeedbackForm,
  BookingFeedbackFormKind,
  ReplaceBookingFeedbackFormRequest,
} from '@mds/shared/types/booking-feedback';
import { dateLabel } from '@mds/shared/lib/format';

import {
  errorCode,
  questionSetDraftOf,
  questionSetInputOf,
  type QuestionSetDraft,
} from '@/domain/form-builder';

/** The desk default covers the coworking floors; the space default every room and facility. */
export const FORM_KIND_LABELS: Record<BookingFeedbackFormKind, string> = {
  desk: 'Desks',
  space: 'Rooms & spaces',
};

export const bookingFeedbackDraftOf = (form: BookingFeedbackForm): QuestionSetDraft =>
  questionSetDraftOf(form);

export const replaceRequestOf = (
  draft: QuestionSetDraft,
  expectedVersion: number,
): ReplaceBookingFeedbackFormRequest => ({ expectedVersion, ...questionSetInputOf(draft) });

/**
 * A space's first form of its own, before it is saved: a copy of its default's questions at
 * version 0, which is what the API takes to create one.
 */
export const ownFormFrom = (
  defaultForm: BookingFeedbackForm,
  resourceId: string,
): BookingFeedbackForm => ({ ...defaultForm, resourceId, version: 0, updatedAt: null });

/** Someone else saved since this copy was loaded. */
export const BOOKING_FEEDBACK_FORM_CHANGED = 'BOOKING_FEEDBACK_FORM_CHANGED';

/** The space asks its default: it has no form of its own to load. */
export const isNoOwnForm = (error: unknown) =>
  errorCode(error) === 'BOOKING_FEEDBACK_FORM_NOT_FOUND';

/** "Mon 12/10/26", or "Mon 12/10/26 – Wed 11/11/26" for a package. */
export const bookingDatesLabel = (start: string, end: string) =>
  start === end ? dateLabel(start) : `${dateLabel(start)} – ${dateLabel(end)}`;
